<div class="main-content">
  <div class="main-heading">
    <span translate>ADD_FDV_REGISTRY</span>
  </div>
  <div class="card">
    <div class="card-body">
      <form [formGroup]="fdvForm">
        <div class="row">
          <div class="col-md-6">
            <div class="sub-panel-title">
              <span translate>ADD_OBJECT</span>
            </div>
            <div class="form">
              <div class="form-group">
                <label class="col-form-label">
                  <span translate>NAME_OF_THE_OBJECT</span>
                  <span class="required">*</span>
                </label>
                <div>
                  <input
                    type="text"
                    class="form-control"
                    maxlength="100"
                    formControlName="objectName"
                  />
                </div>
                <control-messages
                  [control]="fdvForm.controls['objectName']"
                ></control-messages>
              </div>
              <div class="sub-panel-title">
                <span translate>ADDRESS</span>
              </div>
              <div class="form-group">
                <label class="col-form-label">
                  <span translate>ADDRESS</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  maxlength="100"
                  formControlName="address"
                />
              </div>
              <div class="form-group-25_75">
                <div class="form-group">
                  <label class="col-form-label">
                    <span translate>ZIP</span>
                  </label>
                  <div>
                    <input
                      type="number"
                      class="form-control"
                      (keypress)="onNumberChange($event, 20)"
                      formControlName="zip"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-form-label">
                    <span translate>LOCATION</span>
                  </label>
                  <div>
                    <input
                      type="text"
                      class="form-control"
                      maxlength="100"
                      formControlName="location"
                    />
                  </div>
                </div>
              </div>
              <div class="sub-panel-title">
                <span translate>ORGANIZED</span>
              </div>
              <div class="form-group" *ngIf="fdvForm.controls['contact']">
                <label class="col-form-label">
                  <span translate>CONTACT_PERSON</span>
                </label>
                <div>
                  <p-select
                    [options]="contact"
                    [style]="{ width: '160px' }"
                    formControlName="contact"
                  >
                  </p-select>
                </div>
                <control-messages
                  [control]="fdvForm.controls['contact']"
                ></control-messages>
              </div>
              <div class="form-group">
                <label for="EmailDevaition">
                  <span translate>EMAIL_NEWDEVIATION_LABEL</span>
                </label>
                <div *ngIf="bindSelectedUsers">
                  <p-multiSelect
                    placeholder="{{ 'SELECT' | translate }}"
                    [dataKey]="'Id'"
                    [options]="userSubscribers"
                    formControlName="selectedEmailSubscriber"
                    [style]="{ width: '100%' }"
                  >
                    <ng-template
                      let-emailDeviation
                      let-i="index"
                      pTemplate="item"
                    >
                      {{ i }}
                      <span>{{ emailDeviation.label }}</span>
                    </ng-template>
                  </p-multiSelect>
                </div>
                <div *ngIf="bindAllUsers">
                  <p-multiSelect
                    placeholder="{{ 'SELECT' | translate }}"
                    [dataKey]="'Id'"
                    [options]="selectedSubscribers"
                    formControlName="selectAllEmailSubscriber"
                    [style]="{ width: '100%' }"
                  >
                    <ng-template
                      let-emailDeviations
                      let-i="index"
                      pTemplate="item"
                    >
                      {{ i }}
                      <span>{{ emailDeviations.label }}</span>
                    </ng-template>
                  </p-multiSelect>
                </div>
              </div>
              <div class="form-group">
                <div class="checkbox">
                  <label class="kuba-choice-label"><p-checkbox
                    formControlName="IsShowDeviationChecked"
                    binary="true"
                  ></p-checkbox><span>{{ 'DO_NOT_DISPLAY_DEVIATION' | translate }}</span></label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div>
              <div class="form" *ngIf="isChooseProject">
                <div class="sub-panel-title">
                  <span translate>COPYFOLDERS_CONTENT</span>
                </div>
                <div class="form-group">
                  <label class="col-form-label">
                    <span translate>CHOOSE_OBJECT</span>
                  </label>
                  <div>
                    <p-select
                      [options]="chooseObject"
                      formControlName="chooseObject"
                      [style]="{ width: '160px' }"
                    ></p-select>
                  </div>
                </div>
                <div class="form-group">
                  <div class="checkbox">
                    <label class="kuba-choice-label"><p-checkbox
                      value="copy SJA"
                      formControlName="copySpj"
                      binary="true"
                    ></p-checkbox><span>{{ 'COPY_SJA' | translate }}</span></label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-form-label">
                  <span translate>DESCRIPTION</span>
                </label>
                <div>
                  <textarea
                    class="form-control"
                    maxlength="250"
                    formControlName="businessDescription"
                    rows="4"
                  ></textarea>
                </div>
              </div>
              <label class="col-form-label">
                <span translate>ADDIMAGES</span>
              </label>
              <div class="upload-file-container">
                <div class="form-group">
                  <div class="upload-file-container">
                    <div class="upload-actions">
                      <input
                        type="file"
                        id="files"
                        class="hidden"
                        (change)="filesSelect($event)"
                      />
                      <label
                        for="files"
                        class="btn btn-outline-primary"
                        translate
                        >UPLOAD_IMAGE</label
                      >
                    </div>
                    <div *ngIf="uploadStart">
                      <span translate>IMAGE_IS_UPLOADING</span>
                    </div>
                    <div *ngIf="fdvImage != null">
                      <img
                        src="{{ fdvImage }}"
                        alt=""
                        width="200"
                        class="thumbnail"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="sub-panel-title">
                <span translate>ASSIGN_ACCESS</span>
              </div>
              <p-table
                #dt
                [value]="propertyObjectUsers"
                dataKey="Id"
                scrollable="true"
                scrollHeight="400px"
              >
                <!-- Header -->
                <ng-template pTemplate="header">
                  <tr>
                    <th>
                      <p-checkbox
                        [ngModel]="checkedAll"
                        (ngModelChange)="checkAll($event)"
                        [ngModelOptions]="{ standalone: true }"
                        binary="true"
                      ></p-checkbox>
                    </th>
                    <th>{{ "NAME" | translate }}</th>
                  </tr>
                </ng-template>
                <!-- Body Content -->
                <ng-template pTemplate="body" let-vechile>
                  <tr>
                    <td>
                      <p-checkbox
                        [ngModel]="vechile.Id === userId || vechile.status"
                        [disabled]="vechile.Id === userId"
                        (ngModelChange)="vechile.status = $event; checked(vechile)"
                        [ngModelOptions]="{ standalone: true }"
                        binary="true"
                      ></p-checkbox>
                    </td>
                    <td>
                      <span>{{ vechile.Name }}</span>
                    </td>
                  </tr>
                </ng-template>
                <!-- Empty message -->
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td colspan="2">
                      {{ "NO_RECORDS_FOUND" | translate }}
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>

        <div class="action-btns-wrapper">
          <a class="btn btn-outline-secondary" (click)="gotoBack()">
            <i class="pi pi-arrow-left"></i>
            <span translate>BACK_LIST</span>
          </a>
          <button
            type="button"
            class="btn btn-primary addbuton"
            (click)="saveFdv('REDIRECT')"
            [disabled]="!fdvForm.valid"
            *ngIf="isAdministrateFDV"
          >
            <span translate>SAVE</span>
          </button>
          <button
            type="button"
            class="btn btn-primary addbuton"
            (click)="saveFdv('RESET')"
            [disabled]="!fdvForm.valid"
            *ngIf="isHideSaveAndCreateButton"
          >
            <span translate>SAVE_CREATE_NEW</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
